export default __webpack_public_path__ + "static/media/SndLowerBSwimUpOver.e545614a.mp3";